import React, { useEffect, useRef, useState } from "react";
import { CrossIcon, DeleteIcon } from "@/utils/svgs";
import Alert from "@/components/alert/Alert";
import { API_ROUTES } from "@/services/environment";
import { DELETE, GET, POST } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import ChangesAlert from "@/components/alert/ChangesAlert";
import moment from "moment";
import ScheduleSelectTime from "@/components/selectTime/ScheduleSelectTime";
import OneDayTimeSelect from "@/components/selectTime/OneDayTimeSelect";
import TimerList from "@/constants/TimerList";
import addIcon from "../../assets/icons/addIcon.svg";
import deleteIcon from "../../assets/icons/deleteIcon.svg";
import FormModal from "@/components/modals/FormModal";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { Button, convertToAMPM, dateFunctionUS } from "@thdinc/hpf-shared";

import _DatePicker from "react-datepicker";
const DatePicker = _DatePicker as unknown as React.ComponentType<any>;

interface BartenderDateInterFace {
  id?: string;
  date: string;
  start_time: string;
  end_time: string;
  user_id?: string;
}
interface ChildProps {
  id: string;
  bartenderBlocks: BartenderDateInterFace[];
  change: boolean;
  setChange: (value: boolean) => void;
}
const BartenderOneDaySchedule: React.FC<ChildProps> = ({
  id,
  bartenderBlocks,
  setChange,
  change,
}) => {
  const dispatch = useDispatch();
  // Helper function to find the index of a time in TimerList
  const {
    deleteBartenderOneDaySchedule,
    bartenderOneDaySchedule,
    bartenderBlockedDate,
  } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [startTime, setStartTime] = useState("09:00 AM");
  const [endTime, setEndTime] = useState("11:00 PM");

  const getTimeIndex = (time: string) =>
    TimerList.findIndex((t) => t.label === time);
  //   const [changed, setChanged] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [availablDates, setAvailablDates] = useState<BartenderDateInterFace[]>(
    []
  );
  const [excludedDates, setExcludedDates] = useState<Date[]>([]);
  const [modal, setModal] = useState<boolean>(false);
  const [dateModal, setDateModal] = useState<boolean>(false);
  const [blockDates, setBlockDates] = useState<BartenderDateInterFace[]>([]);
  const [showForm, setShowForm] = useState(false);

  const [activeBlock, setActiveBlock] = useState<BartenderDateInterFace | null>(
    null
  );
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const [readyData, setReadyData] = useState<BartenderDateInterFace>({
    date: "",
    start_time: "",
    end_time: "",
  });

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  const getAvailableStartTimes = () => {
    const endIndex = getTimeIndex(endTime);
    const startIndex = Math.max(0, endIndex - 8); // 4 hours before end time (2 slots per hour)
    return TimerList.slice(0, startIndex + 1); // Include the time exactly 4 hours before
  };
  useEffect(() => {
    const getDateAvailabities = async () => {
      const response = await GET(
        bartenderOneDaySchedule + "/" + id,
        refreshToken
      );
      setBlockDates([
        ...bartenderBlocks.map((item: any) => {
          return { ...item, date: moment(item.date).toDate() };
        }),
      ]);
      setAvailablDates(response.data);
      setExcludedDates([
        ...response.data.map((item: BartenderDateInterFace) =>
          moment(item.date).toDate()
        ),
        // ...bartenderBlocks.map(item => moment(item.date).toDate())
      ]);
    };
    getDateAvailabities();
  }, [id, bartenderBlocks.length, change]);
  const getAvailableEndTimes = () => {
    const startIndex = getTimeIndex(startTime);
    return TimerList.slice(startIndex + 8);
  };

  const handleStartTimeChange = (field: string, newValue: string) => {
    setStartTime(newValue);
    const startIndex = getTimeIndex(newValue);
    const minEndIndex = startIndex + 8; // 4 hours later (2 slots per hour)
    if (getTimeIndex(endTime) < minEndIndex) {
      setEndTime(TimerList[minEndIndex].label);
    }
  };

  const handleEndTimeChange = (field: string, newValue: string) => {
    setEndTime(newValue);
    const endIndex = getTimeIndex(newValue);
    const maxStartIndex = Math.max(0, endIndex - 8); // 4 hours before (2 slots per hour)
    if (getTimeIndex(startTime) > maxStartIndex) {
      setStartTime(TimerList[maxStartIndex].label);
    }
  };

  const handleSave = async () => {
    const date = selectedDate && formatDate(selectedDate);
    const body = {
      date: date,
      start_time: TimerList.find((t) => t.label === startTime)?.value,
      end_time: TimerList.find((t) => t.label === endTime)?.value,
    };
    try {
      setLoading(true);
      const response = await POST(
        bartenderOneDaySchedule + "/" + id,
        body,
        refreshToken
      );
      const resDate = response.data;
      if (resDate.success) {
        setAvailablDates([...availablDates, resDate.data]);
        setExcludedDates((prev) => [
          ...prev,
          moment(resDate.data.date).toDate(),
        ]);
        Alert({ message: resDate?.message });
        setSelectedDate(null);
        setChange(!change);
      } else {
        Alert({ type: "error", message: resDate?.message });
      }
      resetAll();
      setLoading(false);
      setActiveIndex(0);
      setActiveBlock(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    // setModal(true);
    setShowForm(false);
  };

  // const createAvailableDate = async () => {
  //   // create a new block date
  //   setModal(false);
  //   try {
  //     setLoading(true);
  //     const response = await POST(
  //       bartenderOneDaySchedule + "/" + id,
  //       readyData,
  //       refreshToken
  //     );
  //     const resDate = response.data;
  //     if (resDate.success) {
  //       setAvailablDates([...availablDates, resDate.data]);
  //       setExcludedDates((prev) => [
  //         ...prev,
  //         moment(resDate.data.date).toDate(),
  //       ]);
  //       Alert({ message: resDate?.message });
  //       setSelectedDate(null);
  //       setChange(!change)
  //     } else {
  //       Alert({ type: "error", message: resDate?.message });
  //     }
  //     resetAll();
  //     setLoading(false);
  //     setActiveIndex(0);
  //     setActiveBlock(null);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  const resetAll = () => {
    // to reset all fields
    // setSelectedDate(new Date());
    setStartTime("09:00 AM");
    setEndTime("06:00 PM");
    // setAllDay(false)
    // setChanged(false)
    dispatch(formStateChange(false));
  };

  const removeAvailableDate = async () => {
    setModal(false);
    try {
      const list = availablDates ? [...availablDates] : [];
      const excludes = [...excludedDates];
      excludes.splice(activeIndex, 1);
      list.splice(activeIndex, 1);
      setAvailablDates([...list]);
      setExcludedDates([...excludes]);
      const response = await DELETE(
        deleteBartenderOneDaySchedule + "/" + activeBlock?.id,
        refreshToken
      );
      Alert({ message: response?.data?.message });
      setChange(!change);
      setActiveIndex(0);
      setActiveBlock(null);
    } catch (error) {
      console.log(error);
    }
  };

  interface TimeRange {
    date: string;
    start_time: string;
    end_time: string;
  }
  function formatTimeRange(timeRange: TimeRange): string {
    const { date, start_time, end_time } = timeRange;
    if (start_time && end_time) {
      // Parse start and end times
      const start = new Date(`${date} ${start_time}`);
      const end = new Date(`${date} ${end_time}`);
      // Calculate duration in hours
      const durationInMs = end.getTime() - start.getTime();
      const durationInHours = durationInMs / (1000 * 60 * 60);
      // Format output string
      const formattedDuration =
        durationInHours === 1 ? "1 hour" : `${durationInHours} hours`;
      return `${dateFunctionUS(date)} ${convertToAMPM(
        start_time
      )} to ${convertToAMPM(end_time)} (${formattedDuration})`;
    }
    return dateFunctionUS(date);
  }

  // == functionality to available a block date
  const selectDateFun = (value: Date) => {
    setSelectedDate(value as Date);
    // setChanged(true);
    dispatch(formStateChange(true));
    blockDates.map((i) => {
      const date = new Date(i.date);
      // if the selected date is in available date
      if (
        `${value?.getDate()}-${value?.getMonth()}-${value?.getFullYear()}` ===
        `${date?.getDate()}-${date?.getMonth()}-${date?.getFullYear()}`
      ) {
        setDateModal(true);
        setActiveBlock(i);
        setShowForm(false);
      }
    });
  };
  const availableBlockDate = async () => {
    const response = await DELETE(
      bartenderBlockedDate + "/" + activeBlock?.id,
      refreshToken
    );
    // if(response.status===200){

    // await createBlockDate()
    // }

    setChange(!change); // for rerender
    setDateModal(false);
    setActiveBlock(null);
    setShowForm(true);
  };
  console.log("showForm", showForm);
  return (
    <div className=" bg-white rounded-2xl  p-6 mt-8">
      <div className="flex justify-between items-center">
        <p className="text-2xl font-semibold">Time On </p>
        <div
          className="bg-p-gray inline-block p-2 rounded-full cursor-pointer"
          onClick={() => setShowForm(!showForm)}
        >
          <img src={addIcon} width={18} height={18} />
        </div>
      </div>
      <FormModal
        width="w-full md:w-[450px]"
        height="min-h-fit"
        modalTitle="Add Availalbe Date"
        isOpen={showForm}
        onClose={() => setShowForm(false)}
      >
        <div className="">
          <div className="flex justify-between items-center">
            <p className="text-gray-700 mt-2">
              Enter the date your bartender is available to work on.
            </p>
          </div>
          <div className=" w-full flex flex-col gap-3">
            <div className="flex flex-col md:flex-row justify-between md:items-center  gap-3">
              <div className=" w-full">
                <div className="font-semibold my-2 text-sm">Select Date</div>
                <DatePicker
                  excludeDates={excludedDates}
                  minDate={new Date()}
                  dateFormat={"MM-dd-yyyy"}
                  className=" w-full cursor-pointer px-4 py-3 bg-p-gray rounded-full    focus:outline-none uppercase focus:ring-1 focus:ring-primary-red  text-gray-600"
                  onChange={selectDateFun}
                  selected={selectedDate ? selectedDate : new Date()}
                />
              </div>
              {/* <div className=" w-full">
              <div className="font-semibold  my-2 text-sm">Start Time</div>
              <OneDayTimeSelect
                field="startTime"
                disabled={!selectedDate}
                value={startTime}
                availableTimes={getAvailableStartTimes()}
                onChange={handleStartTimeChange}
              />
            </div> */}
              {/* <div className=" w-full">
              <div className="font-semibold  my-2 text-sm">End Time</div>

              <OneDayTimeSelect
                field="endTime"
                disabled={!selectedDate}
                value={endTime}
                availableTimes={getAvailableEndTimes()}
                onChange={handleEndTimeChange}
              />
            </div> */}
            </div>
            <div className="flex flex-wrap gap-3 justify-end items-center mt-5">
              <Button
                classes={
                  selectedDate
                    ? "bg-primary-red-button text-white"
                    : "bg-gray-300  text-gray-500"
                }
                disabled={loading || !selectedDate}
                onClick={() => handleSave()}
              >
                {loading ? "Loading.." : "Save"}
              </Button>
            </div>
          </div>
        </div>
      </FormModal>
      <div className="text-gray-500 mb-5 mt-[5px] mr-4 text-[14px]">
        Available Dates and Duration
      </div>

      <div className="flex flex-wrap gap-2 text-center">
        {availablDates &&
          availablDates.map((item, index) => {
            return (
              <div
                key={index}
                className="min-w-64 w-full flex items-center gap-2      focus:outline-none uppercase focus:ring-1 focus:ring-primary-red  "
              >
                <p className=" w-full inline-block text-sm  capitalize tracking-wider text-start font-semibold px-6 py-4 bg-p-gray rounded-full">
                  {/* {` ${format(new Date(item.date), "MM-dd-yyyy")} (All Day)`} */}
                  {` ${format(toZonedTime(item.date,
                Intl.DateTimeFormat().resolvedOptions().timeZone), "MM-dd-yyyy")} (All Day)`}
                </p>
                <div
                  className="cursor-pointer  bg-p-gray rounded-full p-2 w-10 h-10 flex justify-center items-center"
                  onClick={() => {
                    setActiveBlock(item), setActiveIndex(index), setModal(true);
                  }}
                >
                  <img src={deleteIcon} />
                </div>
              </div>
            );
          })}
      </div>
      {/* Delete */}
      <ChangesAlert
        title={"Save Changes"}
        desc={`Are you sure you want to remove this availability?`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          // setShowForm(true)
          setModal(false);
          setActiveBlock(null);
          setActiveIndex(0);
        }}
        handleSaveChanges={removeAvailableDate}
        isOpen={modal}
      />
      <ChangesAlert
        title={"This date is set as block"}
        desc={`Do you want to delete this date from block dates`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          setShowForm(true);
          setDateModal(false), setSelectedDate(new Date());
        }}
        handleSaveChanges={availableBlockDate}
        isOpen={dateModal}
      />
    </div>
  );
};

export default BartenderOneDaySchedule;
